import { Fade } from "react-awesome-reveal";
import { socialLinks } from "../data/socialLinks";

export default function FollowOnGithub() {
  return (
    <Fade delay={2200}>
      <div
        className="top-8 md:top-16 -right-[90px] z-[9999] absolute flex justify-center items-center bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 shadow-2xl rotate-45 transition-all duration-300 cursor-pointer border-2 border-white/20"
      >
        <a
          className="px-[110px] py-3 text-white font-bold"
          href={socialLinks.github}
          target="_blank"
          rel="noreferrer"
        >
          <h1 className="text-[11px] md:text-[18px] font-black tracking-wide">Follow On Github</h1>
        </a>
      </div>
    </Fade>
  );
}
